const e=e=>!!e.id&&"privy-v2"===e.recovery_method;export{e as isUnifiedWallet};
